/**
 * Where the developer docs live, in one place.
 *
 * The docs are pages of this app (`src/app/docs`), served at the **root** of
 * their own host since 2026-08-26: middleware rewrites `/quickstart` to the
 * `/docs/quickstart` page, and redirects `/docs/*` on that host to the clean
 * path. Every link to the docs from the marketing site or the dashboard
 * should build its href from here, so the address changes in one edit.
 *
 * No trailing slash: `docsUrl("quickstart")` composes cleanly.
 */
export const DOCS_URL = "https://docs.paranine.com";

/** A page inside the docs: `docsUrl("api/keys")` -> `…/api/keys`. */
export function docsUrl(path = ""): string {
  const clean = path.replace(/^\/+/, "");
  return clean ? `${DOCS_URL}/${clean}` : DOCS_URL;
}
